const ACCOUNT_ABOUT =   {
  value: 'MAJTAGJ8CK2RMV',
  label: '帐号相关',
  children: [
    {
      value: 'SUBTAGJ8CK3J2M',
      label: '帐号入驻',
    },
    {
      value: 'SUBTAGJ8CK4B31',
      label: '帐号禁言/封禁/注销',
    },
    {
      value: 'SUBTAGJ8CK4U2L',
      label: '帐号人脸认证',
    },
    {
      value: 'SUBTAGJ8CK5GGJ',
      label: '帐号身份证占用',
    },
    {
      value: 'SUBTAGJ8CK63AN',
      label: '帐号资料修改',
    },
    {
      value: 'SUBTAGJ8CK6MM7',
      label: '其他帐号相关问题',
    },
  ],
};

const CONTENT_ABOUT = {
  value: 'MAJTAGJ8CK78OO',
  label: '内容相关',
  children: [
    {
      value: 'SUBTAGJ8CK7QPL',
      label: '文章审核',
    },
    {
      value: 'SUBTAGJ8CK86TB',
      label: '视频审核',
    },
    {
      value: 'SUBTAGJ8CK8JG3',
      label: '内容展现',
    },
    {
      value: 'SUBTAGJ8CK90IO',
      label: '已推荐内容申请下线',
    },
    {
      value: 'SUBTAGJ8CK9DT8',
      label: '其他内容相关问题',
    },
  ],
};

const INFRINGEMENT_COMPLAINT = {
  value: 'MAJTAGJ8CK9VVP',
  label: '侵权投诉',
  children: [
    {
      value: 'SUBTAGJ8CKAU6F',
      label: '举报抄袭',
    },
    {
      value: 'SUBTAGJ8CKBBH8',
      label: '帐号同名',
    },
    {
      value: 'SUBTAGJ8CKBP5K',
      label: '其他侵权投诉问题',
    },
  ],
};

const PROFIT =  {
  value: 'MAJTAGJ8CKCUHE',
  label: '收益结算/提现',
  children: [
    {
      value: 'SUBTAGJ8CKDD98',
      label: '收益结算',
    },
    {
      value: 'SUBTAGJ8CKDTDI',
      label: '提现',
    },
    {
      value: 'SUBTAGJ8CKEAT7',
      label: '其他收益结算/提现问题',
    },
  ],
};

const INTERESTS = {
  value: 'MAJTAGJ8CKEQQT',
  label: '权益功能',
  children: [
    {
      value: 'SUBTAGJ8CKFFG9',
      label: '成长体系',
    },
    {
      value: 'SUBTAGJ8CL28UC',
      label: '帐号原创',
    },
    {
      value: 'SUBTAGJ8CL2QD4',
      label: '帐号认证',
    },
    {
      value: 'SUBTAGJ8CKGAV0',
      label: '帐号功能',
    },
    {
      value: 'SUBTAGJ8CL3CUU',
      label: '其他权益功能问题',
    },
  ],
};

const BRAND_NUMBER_RELATED = {
  value: 'MAJTAGJ9NODAVK',
  label: '品牌号相关',
  children: [
    {
      value: 'SUBTAGJBT9QS7H',
      label: '品牌号相关',
    },
  ],
};

const MCN_ABOUT = {
  value: 'MAJTAGJ8CL40DV',
  label: 'mcn相关',
  children: [
    {
      value: 'SUBTAGJ8CL4IRM',
      label: 'mcn帐号举报',
    },
    {
      value: 'SUBTAGJ8CL50B6',
      label: 'mcn帐号内容举报',
    },
    {
      value: 'SUBTAGJ8CL5DU1',
      label: '其他mcn相关问题',
    },
  ],
};

const FEEDBACK = {
  value: 'MAJTAGJ8CL6TOE',
  label: '意见与建议',
  children: [
    {
      value: 'SUBTAGJ8CL7UBC',
      label: 'PC意见与建议',
    },
    {
      value: 'SUBTAGJ8CL8CQP',
      label: '移动端意见与建议',
    },
    {
      value: 'SUBTAGJ8CL8QJ8',
      label: '其他意见与建议',
    },
  ],
};

const QUESTION_TYPE = [
  ACCOUNT_ABOUT,
  CONTENT_ABOUT,
  INFRINGEMENT_COMPLAINT,
  PROFIT,
  INTERESTS,
  MCN_ABOUT,
  FEEDBACK,
];

// 帐号相关、侵权投诉、意见与建议、mcn相关
export const UN_LINE_QUESTION_TYPE = [
  ACCOUNT_ABOUT,
  INFRINGEMENT_COMPLAINT,
  FEEDBACK,
  MCN_ABOUT,
];

// 帐号相关、意见与建议、mcn相关
export const WARNING_ACCOUNT_QUESTION_TYPE = [
  ACCOUNT_ABOUT,
  FEEDBACK,
  MCN_ABOUT,
];

// 品牌号相关
export const BRAND_NUMBER_RELATED_TYPE = [
  BRAND_NUMBER_RELATED,
];

const TOPIC_ID_MAP = {
  MAJTAGJ8CK2RMV: '00019ADA,00019MQT,00019ADC,00019ADB,00019AD9',
  MAJTAGJ8CK78OO: '00019ADI,00019ADF,00019ADG,00019ADH',
  MAJTAGJ8CK9VVP: '00019ADK',
  MAJTAGJ8CKCUHE: '00019ADQ,00019ADP',
  MAJTAGJ8CKEQQT: '00019ADU,00019ADT,00019ADS',
};

export { QUESTION_TYPE, TOPIC_ID_MAP };
export default QUESTION_TYPE;

